import React, {useEffect} from 'react'
import "../../styles/Profile.css"
import { fetchProfile } from '../../store/reducers/userData'
import { useSelector, useDispatch } from 'react-redux'

export default function Profile() {

  const userData = useSelector(state=>state.userData)
  const token = useSelector(state=>state.auth.accessToken)
  const profile = useSelector(state=>state.userData.profile)
    
  
  const dispatch = useDispatch()

    useEffect(()=>{
        if(profile.name === null){
            dispatch(fetchProfile(token))
        }
    },[])

  return (
    <div>
        <div className="testHeader pageHeader">
               <h1>Profile</h1>
        </div>
        <div className='profileBox'>
            <div className='profileElement'>
                <span className='profileKeys'>Name :</span> 
                <span className='profileValues'>{profile.name}</span>
            </div>
            <div className='profileElement'>
                <span className='profileKeys'>Date of Birth :</span> 
                <span className='profileValues'>{profile.dob}</span>
            </div>
            <div className='profileElement'>
                <span className='profileKeys'>Email :</span> 
                <span className='profileValues'>{profile.email}
                </span>
            </div>
            <div className='profileElement'>
                <span className='profileKeys'>Phone :</span> 
                <span className='profileValues'>{profile.phone}</span>
            </div>
        </div>
    </div>
  )
}
